import { Component, OnInit, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Crop } from '../../shared/services/crop.service';
import { ReportingService } from '../services/reporting.service';
import { FileSaverService } from '../../shared/services/file-saver.service';
import { ReportingFilterOptions, REPORTING_FILTER_OPTIONS } from '../services/reporting-filter-options.service';
import { AlphabeticalNamedSorter } from '../../shared/sort-methods';
import { LoadingWrapperService } from '../../shared/services/loading-wrapper.service';
import { finalize } from 'rxjs/operators';
import { AlertService } from '../../shared/services/alert.service';
import { SamplingReportFormGroup } from './sampling-report-form-group';
import { Laboratory, Assay } from '../../shared/services/laboratory.service';
import { GrowthStage } from '../../shared/services/growth-stage.service';

@Component({
  selector: 'app-sampling-report-form',
  templateUrl: './sampling-report-form.component.html'
})
export class SamplingReportFormComponent implements OnInit {
  public rootForm: SamplingReportFormGroup;

  public get plantingDateRangeFormControl(): FormControl {
    return this.rootForm.plantingDateRangeFormControl;
  }

  public get samplingDateRangeFormControl(): FormControl {
    return this.rootForm.samplingDateRangeFormControl;
  }

  public get cropFormControl(): FormControl {
    return this.rootForm.cropFormControl;
  }

  public get laboratoryFormControl(): FormControl {
    return this.rootForm.laboratoryFormControl;
  }

  public get laboratoryAssayFormControl(): FormControl {
    return this.rootForm.laboratoryAssayFormControl;
  }

  public get growthStageFormControl(): FormControl {
    return this.rootForm.growthStageFormControl;
  }

  public get plantingDateRange(): Date[] {
    return this.rootForm.plantingDateRangeFormControl && <Date[]> this.rootForm.plantingDateRangeFormControl.value;
  }

  public get samplingDateRange(): Date[] {
    return this.rootForm.samplingDateRangeFormControl && <Date[]> this.rootForm.samplingDateRangeFormControl.value;
  }

  public get plantingStartDate(): Date {
    return this.plantingDateRange && this.plantingDateRange.length > 1 && this.plantingDateRange[0];
  }

  public get plantingEndDate(): Date {
    return this.plantingDateRange && this.plantingDateRange.length > 1 && this.plantingDateRange[1];
  }

  public get samplingStartDate(): Date {
    return this.samplingDateRange && this.samplingDateRange.length > 1 && this.samplingDateRange[0];
  }

  public get samplingEndDate(): Date {
    return this.samplingDateRange && this.samplingDateRange.length > 1 && this.samplingDateRange[1];
  }

  public crops: Crop[];
  public laboratories: Laboratory[];
  public laboratoryAssays: Assay[];
  public growthStages: GrowthStage[];

  constructor(@Inject(REPORTING_FILTER_OPTIONS) options: ReportingFilterOptions, 
    private loadingService: LoadingWrapperService, 
    private alertService: AlertService,
    private reportingService: ReportingService,
    private reportWriterService: FileSaverService) { 
    this.rootForm = new SamplingReportFormGroup();
    options.crops.subscribe(c => this.crops = c.sort(AlphabeticalNamedSorter));
    options.laboratories.subscribe(l => this.laboratories = l.sort(AlphabeticalNamedSorter));
    options.growthStages.subscribe(s => this.growthStages = s.sort(AlphabeticalNamedSorter));

    this.laboratoryFormControl
        .valueChanges
        .subscribe(laboratoryId => this.onLaboratoryChange(laboratoryId));
  }

  ngOnInit() { }

  public generateReport(): void {
    this.loadingService.setMessage('Generating sampling report...');

    this.reportingService.getSamplingReport({
        plantingStartDate: this.plantingStartDate,
        plantingEndDate: this.plantingEndDate,
        samplingStartDate: this.samplingStartDate,
        samplingEndDate: this.samplingEndDate,
        cropId: this.cropFormControl.value,
        laboratoryId: this.laboratoryFormControl.value,
        laboratoryAssayId: this.laboratoryAssayFormControl.value,
        growthStageId: this.growthStageFormControl.value
    })      
    .pipe(finalize(() => this.loadingService.clearMessage()))
    .subscribe(
      file => this.reportWriterService.save(file), 
      error => this.alertService.error('Error generating sampling report.'));
  }

  private onLaboratoryChange(laboratoryId: number): void {
      console.log('changed');
      this.laboratoryAssayFormControl.setValue(null);
    this.laboratoryAssays = laboratoryId === null ? [] : this.laboratories.find(l => l.id === laboratoryId).assays;
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/reporting/sampling-report-form/sampling-report-form.component.ts